import autosize from "autosize";

export default class AutoSizer {
  constructor(node) {
    this.element = node;

    this.initialize();
  }

  initialize() {
    this.textAreaObserver = new IntersectionObserver((entries) => this.updateInitialHeight(entries));
    this.textAreaObserver.observe(this.element);

    this.element.addEventListener("input", autosize(this.element));
  }

  updateInitialHeight(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        autosize.update(this.element);
        this.textAreaObserver.unobserve(this.element);
      }
    });
  }
}
